export default "__VITE_PUBLIC_ASSET__2100890c__"